import { render, staticRenderFns } from "./CoreImageSlider.vue?vue&type=template&id=0e9a0114&scoped=true&"
import script from "./CoreImageSlider.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CoreImageSlider.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./CoreImageSlider.vue?vue&type=style&index=0&id=0e9a0114&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9a0114",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e9a0114')) {
      api.createRecord('0e9a0114', component.options)
    } else {
      api.reload('0e9a0114', component.options)
    }
    module.hot.accept("./CoreImageSlider.vue?vue&type=template&id=0e9a0114&scoped=true&", function () {
      api.rerender('0e9a0114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreImageSlider/CoreImageSlider.vue"
export default component.exports